<template>
  <div style="text-align:left">
    <Breadcrumb style="margin: 0px 10px 20px">
        <BreadcrumbItem to="/planAdmin">投放管理</BreadcrumbItem>
        <BreadcrumbItem>新建投放计划</BreadcrumbItem>
    </Breadcrumb>
    <Card>
		<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150" label-position="left" style="margin-left:10px">
            <FormItem label="投放状态" prop="enable_flag">
                <RadioGroup v-model="formValidate.enable_flag">
                    <Radio label="0">未投放</Radio>
                    <Radio label="1">投放</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="投放计划名称" prop="plan_name">
                <Input v-model="formValidate.plan_name" style="width:300px" ></Input>
            </FormItem>
            <FormItem label="投放日期" prop="start_at">
                <DatePicker type="date" :value="formValidate.start_at" placeholder="开始日期" style="width:300px" @on-change="handleChange"></DatePicker>
            </FormItem>
            <FormItem label="投放广告" prop="ad_id">
                <Select v-model="formValidate.ad_id" style="width:300px" filterable clearable :remote-method="remoteMethod" :loading="loading" @on-change="handleChangeAd" @on-clear="handleClear">
                    <Option v-for="(item,index) in advertisements" :value="item.ad_id" :key="item.ad_id">{{item.title}}</Option>
                </Select>
                {{ formValidate.ad_id }}
            </FormItem>
            <Divider />
            <FormItem label="广告切换方式" prop="ad_switch_type">
                <RadioGroup v-model="formValidate.ad_switch_type">
                    <Radio label="0">不切换</Radio>
                    <Radio label="1">轮换</Radio>
                    <Radio label="2">AB测</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="用户兴趣监控" v-show="formValidate.ad_switch_type == 1">
                <Row style="margin-bottom:8px">
                    <RadioGroup v-model="formValidate.rotation_type">
                        <Radio label="1">定时未点击</Radio>
                        <Radio label="2">定时自动</Radio>
                    </RadioGroup>
                </Row>
                <Row v-show="formValidate.rotation_type == '1'">
                    用户加载广告
                    <InputNumber v-model="formValidate.rotation_interval_days" style="width: 60px; margin: 0 5px" :min="0"></InputNumber>
                    天内，未点击任一广告，则触发轮换
                </Row>
                <Row v-show="formValidate.rotation_type == '2'">
                    用户加载广告
                    <InputNumber v-model="formValidate.rotation_interval_days" style="width: 60px; margin: 0 5px" :min="0"></InputNumber>
                    天后，自动轮换
                </Row>
            </FormItem>
            <FormItem label="轮换投放计划1" v-show="formValidate.ad_switch_type == 1">
                <Select v-model="formValidate.rotation_ad_ids[0]" style="width:300px" filterable clearable @on-query-change="(q)=>remoteMethod1(q,0)" :loading="loading1" placeholder="广告样式相同">
                    <Option v-for="(item,index) in (rotationAdsList[0] ? rotationAdsList[0] : rotationAds)" :value="item.ad_id" :key="item.ad_id">{{item.title}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 10px;" @click="addRotationPlan" :disabled="formValidate.rotation_ad_ids.length >= 6">增加</Button>
            </FormItem>
            <FormItem v-for="(_, index) in formValidate.rotation_ad_ids.slice(1)" :key="index + 1" :label="'轮换投放计划' + (index + 2)" v-show="formValidate.ad_switch_type == 1">
                <Select v-model="formValidate.rotation_ad_ids[index + 1]" style="width:300px" filterable clearable @on-query-change="(q)=>remoteMethod1(q, index + 1)" :loading="loading1" placeholder="广告样式相同">
                    <Option v-for="(item,idx) in (rotationAdsList[index + 1] ? rotationAdsList[index + 1] : rotationAds)" :value="item.ad_id" :key="item.ad_id">{{item.title}}</Option>
                </Select>
                <Button type="error" style="margin-left: 10px;" @click="removeRotationPlan(index + 1)">删除</Button>
            </FormItem>
            <FormItem label="AB测试" v-show="formValidate.ad_switch_type == 2">
                测试时间
                <InputNumber v-model="formValidate.ab_test_duration_hours" style="width: 60px; margin: 0 5px" :min="0"></InputNumber>
                小时
            </FormItem>
            <FormItem label="B组投放计划" v-show="formValidate.ad_switch_type == 2">
                <Select v-model="formValidate.ab_test_ad_id" style="width:300px" filterable clearable @on-query-change="remoteMethod2" :loading="loading2" placeholder="内容和链接相同，仅图片素材不同">
                    <Option v-for="(item,index) in abTestAds" :value="item.ad_id" :key="item.ad_id">{{item.title}}</Option>
                </Select>
            </FormItem>
            <Divider />
            <FormItem label="优先级" prop="plan_order">
                <Row>
                    <Col span="18">
                        <InputNumber v-model="formValidate.plan_order" style="width: 60px;" :min="0" :max="10"></InputNumber>
                        <span>(0为最高，同一广告版位，优先展示权重高的投放计划)</span>
                    </Col>
                </Row>
            </FormItem>
            <FormItem label="广告媒体" prop="medias">
                <CheckboxGroup v-model="formValidate.medias" @on-change="handleChangeMedia">
                    <div class="box">
                        <div v-for="(value,key,index) in categories">
                            <Row>
                                <span style="color: rgb(158, 156, 156);font-size:12px">{{key}}</span>
                            </Row>
                            <Row>
                                <Checkbox v-for="(item,i) in value" :label="key+';'+item.medium_name" :key="item.medium_name" :disabled="item.available_flag=='0'">{{item.medium_name}}</Checkbox>
                            </Row>
                        </div>
                    </div>
                </CheckboxGroup>
            </FormItem>
            <FormItem label="广告版位" prop="placements">
                <CheckboxGroup v-model="formValidate.placements" @on-change="handleChangePlacements">
                    <div class="box1">
                        <div v-for="(value,key,index) in placements">
                            <Row>
                                <span style="color: rgb(158, 156, 156);font-size:12px">{{key}}</span>
                            </Row>
                            <Row>
                                <Checkbox v-for="(item,i) in value" :label="item.placement_id" :key="item.placement_id">{{item.placement_name}}</Checkbox>
                            </Row>
                        </div>
                    </div>  
                </CheckboxGroup>
            </FormItem>
            <FormItem label="是否对会员显示" prop="show_to_vip_flag">
                <RadioGroup v-model="formValidate.show_to_vip_flag">
                    <Radio label="0">不显示</Radio>
                    <Radio label="1">显示</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="投放方式" prop="plan_type">
                <RadioGroup v-model="formValidate.plan_type" vertical>
                    <Radio label="1" style="height:40px">
                        <span>按投放天数</span>
                        <InputNumber v-model="formValidate.dates" style="width:100px" :min="1"></InputNumber> 天
                    </Radio>
                    <Radio label="2" style="height:40px">
                        <span>按曝光次数</span>
                        <InputNumber v-model="formValidate.show_count" style="width:100px" :min="1"></InputNumber> 次
                    </Radio>
                    <Radio label="3" style="height:40px">
                        <span>按点击次数</span>
                        <InputNumber v-model="formValidate.click_count" style="width:100px" :min="1"></InputNumber> 次
                    </Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="定向投放">
                <div class="box2">
                    <Row style="margin:0px 0px 10px">
                        <Col span="8">
                            定向投放人群
                        </Col>
                        <Col span="16">
                            <Select v-model="formValidate.target_recipient_ids" multiple filterable :on-query-change="handleSearchCrowds">
                                <Option v-for="(item,index) in crowds" :value="String(item.crowd_id)" :key="item.crowd_id">{{item.crowd_name}}</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style="margin:0px 0px 10px">
                        <Col span="8">
                            禁止投放人群
                        </Col>
                        <Col span="16">
                            <Select v-model="formValidate.excluded_recipient_ids" multiple filterable :remote-method="handleSearchCrowds">
                                <Option v-for="(item,index) in crowds" :value="String(item.crowd_id)" :key="item.crowd_id">{{item.crowd_name}}</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style="margin:0px 0px 10px">
                        <Col span="8">
                            最低版本（包含）
                        </Col>
                        <Col span="16">
                            <Input v-model="formValidate.min_revision" placeholder="默认不限，可输入版本号限制，如：3.16.0" />
                        </Col>
                    </Row>
                    <Row style="margin:0px 0px 10px">
                        <Col span="8">
                            最高版本（包含）
                        </Col>
                        <Col span="16">
                            <Input v-model="formValidate.max_revision" placeholder="默认不限，可输入版本号限制，如：3.16.0" />
                        </Col>
                    </Row>
                    <Row style="margin:0px 0px 10px">
                        <Col span="8">
                            平台
                        </Col>
                        <Col span="16">
                            <Select v-model="formValidate.platform">
                                <Option value="不限">不限</Option>
                                <Option value="android">安卓</Option>
                                <Option value="iphone">IOS</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style="margin:10px 0px">
                        <Col span="8">
                            性别
                        </Col>
                        <Col span="16">
                            <Select v-model="formValidate.gender">
                                <Option value="-1">不限</Option>
                                <Option value="1">男</Option>
                                <Option value="0">女</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style="margin:10px 0px"> 
                        <Col span="8">
                            年龄
                        </Col>
                        <Col span="16">
                            <Select v-model="formValidate.age" :multiple="true">
                                <Option value="~">不限</Option>
                                <Option value="14~18">14~18</Option>
                                <Option value="19~24">19~24</Option>
                                <Option value="25~29">25~29</Option>
                                <Option value="30~39">30~39</Option>
                                <Option value="40~49">40~49</Option>
                                <Option value="50~">50岁以上</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style="margin:10px 0px"> 
                        <Col span="8">
                            手机品牌
                        </Col>
                        <Col span="16">
                            <Select v-model="formValidate.cellphone_brand" :multiple="true">
                                <Option value="不限">不限</Option>
                                <Option value="华为">华为</Option>
                                <Option value="其他">其他</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style="margin:10px 0px">
                        <Col span="8">
                            指定品牌
                        </Col>
                        <Col span="16">
                            <Select v-model="formValidate.brand" multiple>
                            </Select>
                        </Col>
                    </Row>
                    <Row style="margin:10px 0px">
                        <Col span="8">
                            指定设备内部型号
                        </Col>
                        <Col span="16">
                            <Input v-model="formValidate.Internal_model" type="textarea" :rows="3" size='large' placeholder="不同内部型号间用“、”隔开，如US10、A890" />
                        </Col>
                    </Row>
                </div>  
            </FormItem>
            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            </FormItem>
		</Form>
        <Modal
            v-model="msg_modal"
            :title="msg_title"
            width='600'
            footer-hide>
            <Table :columns="msg_columns" :data="msg_data"></Table>
        </Modal>
	</Card>
    
  </div>
</template>
<script>
import{adPlacementList,adList,createPlan,crowdList,rotationAdList,abTestAdList}from "@/request/api"
import Cookies from 'js-cookie';
export default {
name: 'createPlan',
meta:{},
data() {
    return {
        loading:false,
        loading1:false,
        loading2:false,
        advertisements: [],
        rotationAds: [],
        rotationAdsList: [],
        abTestAds: [],
        formValidate:{
            enable_flag: '0',
            only_specific_recipient_flag: '0',
            placements: [],
            dates: 1,
            show_count: 1,
            click_count: 1,
            plan_type: '1',
            start_at: '',
            brand: [],
            Internal_model: '',
            gender: '-1',
            age: ['~'],
            cellphone_brand: ['不限'],
            ad_id: '',
            medias:[],
            show_to_vip_flag: '1',
            platform: '不限',
            min_revision: '',
            max_revision: '',
            target_recipient_ids: [],
            excluded_recipient_ids: [],
            ad_switch_type: '0',
            rotation_type: '1',
            rotation_interval_days: 0,
            rotation_ad_ids: [''],
            ab_test_duration_hours: 0,
            ab_test_ad_id: '',
            plan_order: 0,
        },
        categories:{},
        placements:{},
        total_count:0,
        page:1,
        ruleValidate: {
                only_specific_recipient_flag: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ],
                plan_name: [
                    { required: true, message: 'The name cannot be empty', trigger: 'blur' }
                ],
                ad_id: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ],
                enable_flag: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ],
                plan_type: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ],
                medias: [
                    { required: true, type: 'array', min: 1, message: 'Choose at least one media', trigger: 'change' }
                ],
                placements: [
                    { required: true, type: 'array', min: 1, message: 'Choose at least one placement', trigger: 'change' }
                ],
                start_at: [
                    { required: true,  message: 'Please select the date', trigger: 'change' }
                ],
                plan_order: [
                    { required: true, type: 'number', message: 'Please input the priority', trigger: 'change' }
                ]
            },
            msg_modal: false,
            msg_title: '',
            msg_columns: [
                {
                    title: "应用类别",
                    key: "category",
                    align: "center"
                },
                {
                    title: "应用名称",
                    key: "medium_name",
                    align: "center"
                },
                {
                    title: "广告位名称",
                    key: "plancement_name",
                    align: "center"
                }
            ],
            msg_data: [],
            crowds: []
        };
    },
    methods: {
        getAdList(page=1,page_size=20,title=''){
            adList({page,page_size,title}).then(res=>{
                this.loading = false;
                if(res.data.code==200){
                    this.advertisements=res.data.data.advertisements
                }
            })
        },
        getRotationAdList(ad_id='',page=1,page_size=20,title='',listIndex=null){
            rotationAdList({ad_id,page,page_size,title}).then(res=>{
                this.loading1 = false;
                if(res.data.code==200){
                    const ads = res.data.data.advertisements
                    if(title && listIndex !== null && listIndex !== undefined){
                        this.$set(this.rotationAdsList, listIndex, ads)
                    }else{
                        this.rotationAds = ads
                    }
                }
            })
        },
        getABTestAdList(ad_id='',page=1,page_size=20,title=''){
            abTestAdList({ad_id,page,page_size,title}).then(res=>{
                this.loading2 = false;
                if(res.data.code==200){
                    this.abTestAds = res.data.data.advertisements
                }
            })
        },
        getAdPlacementList(){
            adPlacementList({ad_id: this.formValidate.ad_id}).then(res=>{
                if(res.data.code==200){
                    this.categories = res.data.data.categorys
                }
            })
        },
        getCrowdList(crowd_name){
            crowdList({crowd_name}).then(res=>{
                if(res.data.code==200){
                    this.crowds=res.data.data.crowds
                }
            })
        },
        handleChangeMedia(){
            this.placements = {}
            // 可选的版位
            let optional_placements = []
            this.formValidate.medias.forEach((item, index) => {
                let result = item.split(";")
                let medium_name = result[1]
                let medias = this.categories[result[0]]
                medias.forEach((media, index) => {
                    if(media.medium_name == medium_name){
                        let value = media.placements
                        this.placements[medium_name] = value
                        value.forEach((item, index) => {
                            optional_placements.push(item.placement_id)
                        })
                    }
                })
            })
            // 去掉未选媒体的版位
            let final_select_placements = []
            this.formValidate.placements.forEach((item, index) => {
                if (optional_placements.indexOf(item) > -1){
                    final_select_placements.push(item)
                }
            })
            this.formValidate.placements = final_select_placements
        },
        handleChangePlacements(){
        },
        handleSubmit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    let placements = this.formValidate.placements.join(',')
                    let target_number = 0
                    if(this.formValidate.plan_type == '1'){
                        target_number = this.formValidate.dates
                    }else if(this.formValidate.plan_type == '2'){
                        target_number = this.formValidate.show_count
                    }else if(this.formValidate.plan_type == '3'){
                        target_number = this.formValidate.click_count
                    }
                    let age = this.formValidate.age.join(',')
                    if (age == '') {
                        age = '~'
                    }
                    let cellphone_brand = this.formValidate.cellphone_brand.join(',')
                    if (cellphone_brand == '') {
                        cellphone_brand = '不限'
                    }
                    let min_revision_valid = this.checkRevision(this.formValidate.min_revision)
                    let max_revision_valid = this.checkRevision(this.formValidate.max_revision)
                    if (!min_revision_valid || !max_revision_valid){
                        this.$Message.error('app版本格式有误，数据和小数点组合，开头和结尾为数字')
                        return false
                    }
                    let app_revision = this.formValidate.min_revision.trim() + '~' + this.formValidate.max_revision.trim()
                    let target_recipient_ids = this.formValidate.target_recipient_ids.join(',')
                    let excluded_recipient_ids = this.formValidate.excluded_recipient_ids.join(',')
                    let rotation_ad_ids_str = ''
                    if (this.formValidate.ad_switch_type == '0'){
                        this.formValidate.rotation_interval_days = 0
                        this.formValidate.rotation_ad_ids = ['']
                        this.formValidate.ab_test_duration_hours = 0
                        this.formValidate.ab_test_ad_id = ''
                    } else if (this.formValidate.ad_switch_type == '1'){
                        this.formValidate.ab_test_duration_hours = 0
                        this.formValidate.ab_test_ad_id = '' 
                        if (!this.formValidate.rotation_interval_days || this.formValidate.rotation_interval_days <= 0){
                            this.$Message.error('轮播间隔时间必须大于0')
                            return false   
                        }
                        rotation_ad_ids_str = this.formValidate.rotation_ad_ids.filter(id => id && id !== '').join(',')
                        if(!rotation_ad_ids_str){
                            this.$Message.error('轮播广告不能为空')
                            return false
                        }       
                    } else if (this.formValidate.ad_switch_type == '2'){
                        this.formValidate.rotation_interval_days = 0
                        this.formValidate.rotation_ad_ids = ['']
                        if (!this.formValidate.ab_test_duration_hours || this.formValidate.ab_test_duration_hours <= 0){
                            this.$Message.error('测试时间必须大于0')
                            return false   
                        }
                        if(!this.formValidate.ab_test_ad_id){
                            this.$Message.error('测试广告不能为空')
                            return false
                        }
                    }
                    createPlan(
                        {
                            only_specific_recipient_flag: parseInt(this.formValidate.only_specific_recipient_flag),
                            enable_flag: parseInt(this.formValidate.enable_flag),
                            plan_name: this.formValidate.plan_name,
                            ad_id: this.formValidate.ad_id,
                            start_at: this.formValidate.start_at,
                            placement_ids: placements,
                            plan_type: parseInt(this.formValidate.plan_type),
                            target_number: target_number,
                            gender: parseInt(this.formValidate.gender),
                            age: age,
                            cellphone_brand: cellphone_brand,
                            brand: this.formValidate.brand.join(','),
                            Internal_model: this.formValidate.Internal_model,
                            show_to_vip_flag: parseInt(this.formValidate.show_to_vip_flag),
                            platform: this.formValidate.platform,
                            app_revision: app_revision,
                            target_recipient_ids: target_recipient_ids,
                            excluded_recipient_ids: excluded_recipient_ids,
                            ad_switch_type: parseInt(this.formValidate.ad_switch_type),
                            rotation_type: parseInt(this.formValidate.rotation_type),
                            rotation_interval_days: this.formValidate.rotation_interval_days,
                            rotation_ad_ids: rotation_ad_ids_str,
                            ab_test_duration_hours: this.formValidate.ab_test_duration_hours,
                            ab_test_ad_id: this.formValidate.ab_test_ad_id,
                            plan_order: this.formValidate.plan_order,
                        }
                    ).then(res=>{
                        if(res.data.code==200){
                            this.$Message.success('Success!');
                            this.$router.back(-1);
                        }else{
                            this.$Message.error(res.data.msg);
                            this.msg_title = res.data.msg
                            this.msg_data = res.data.data.sub_msg
                            this.msg_modal = true
                        }
                    })
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        remoteMethod (query) {
            this.loading = true
            let title = query.trim()
            this.getAdList(1, 20, title)
        },
        handleSearchCrowds (query) {
            this.getCrowdList(query)
        },
        handleClear(){
            this.getAdList(1, 20)
        },
        handleChange (date) {
            this.formValidate.start_at = date
        },
        handleChangeAd(){
            if(this.formValidate.ad_id){
                this.formValidate.medias = []
                this.categories={}
                this.placements={}
                this.getAdPlacementList()
                this.formValidate.rotation_ad_ids = ['']
                this.formValidate.ab_test_ad_id = ''
                this.formValidate.rotation_interval_days = 0
                this.formValidate.ab_test_duration_hours = 0
                this.getRotationAdList(this.formValidate.ad_id)
                this.getABTestAdList(this.formValidate.ad_id)
            }
        },
        checkRevision(revision){
            revision = revision.trim()
            if (revision != ''){
                let lastChar = revision.slice(-1)
                let firstChat = revision[0]
                if (isNaN(lastChar) || isNaN(firstChat)) {
                    return false
                }
                revision = revision.replace(/\./g, "")
                let isNumber = /^\d+$/g.test(revision)
                if (!isNumber){
                    return false
                }
                return true
            }
            return true
        },
        remoteMethod1 (query, index) {
            // 若查询为空，清除索引对应的自定义列表，回退到公共列表
            if (!query || query.trim() === '') {
                this.$set(this.rotationAdsList, index, undefined)
                this.loading1 = true;
                // 刷新公共列表（不传索引）
                this.getRotationAdList(this.formValidate.ad_id, 1, 20, '', null)
                return
            }
            this.loading1 = true;
            this.getRotationAdList(this.formValidate.ad_id, 1, 20, query, index)
        },
        remoteMethod2 (query) {
            this.loading2 = true;
            this.getABTestAdList(this.formValidate.ad_id, 1, 20, query)
        },
        addRotationPlan(){
            if(this.formValidate.rotation_ad_ids.length < 6){
                this.formValidate.rotation_ad_ids.push('')
                this.getRotationAdList(this.formValidate.ad_id, 1, 20, '')
            }
        },
        removeRotationPlan(index){
            if(index > 0){
                this.formValidate.rotation_ad_ids.splice(index, 1)
                this.rotationAdsList.splice(index, 1)
            }
        },
    },
    created() {
        Cookies.set('active_name', '3');
        this.getAdList(1, 20)
        this.getCrowdList('')
    },
};
</script>
<style scoped>
.box{
  max-width: 450px;
  min-height: 30px;
  border:1px solid rgb(158, 156, 156);
  padding: 10px;
  /* margin: 0px 20px 20px; */
}
.box1{
  max-width: 450px;
  /* height: 280px; */
  border:1px solid rgb(158, 156, 156);
  padding: 10px 10px 20px;
  /* margin: 0px 20px 20px; */
}
.box2{
  max-width: 450px;
  /* height: 280px; */
  border:1px solid rgb(158, 156, 156);
  padding: 10px 10px 20px;
  /* margin: 0px 20px 20px; */
}
</style>


// WEBPACK FOOTER //
// src/views/Plan/PlanCreate.vue